import React from 'react'
import { useRouter } from 'next/router'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'
import { TranslationDictionary, dateFormatMask, format } from '@plandi/common'
import Link from 'next/link'

import { EmptyContent, URLS } from 'src/common'
import { useQueryProjectChats } from 'src/features/projects/common'
import { useProjectChatListStyles } from './project-chat-list.styles'
import { ProjectChatListPlaceholder } from './project-chat-list-placeholder'

type ProjectChatListProps = {
  translate?: TranslationDictionary['data']
}

export const ProjectChatList: React.FC<ProjectChatListProps> = ({
  translate
}) => {
  const classes = useProjectChatListStyles()
  const router = useRouter()

  const projectId = router.query.projectId
    ? Number(router.query.projectId)
    : undefined

  const { data: projectChats, isLoading } = useQueryProjectChats(projectId)

  if (!projectChats?.length && !isLoading) {
    return (
      <EmptyContent
        showButton
        message={translate?.shop['project-no-responses']}
        buttonProps={{
          text: translate?.shop['to-my-projects'],
          href: URLS.projects.me
        }}
      />
    )
  }

  return (
    <>
      {isLoading ? (
        <ProjectChatListPlaceholder />
      ) : (
        projectChats?.map((projectChat) => (
          <Link
            key={projectChat.id}
            href={{
              pathname: URLS.projects.chats.detail,
              query: {
                projectId,
                chatId: projectChat.id,
                slugName: router.query.slugName || 'no-slug-name'
              }
            }}
            passHref
          >
            <Card elevation={0} className={classes.root} component="a">
              <CardContent className={classes.content}>
                <CardMedia
                  image={projectChat.author?.avatarUrl ?? ''}
                  title={projectChat.author?.name}
                  className={classes.avatar}
                />
                <Typography
                  variant="subtitle1"
                  className={classes.authorName}
                  noWrap
                >
                  {projectChat.author?.name}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  className={classes.date}
                >
                  {projectChat.message?.createdAt &&
                    dateFormatMask(
                      projectChat.message?.createdAt,
                      format.shortFullDate
                    )}
                </Typography>
                <Typography variant="body2" className={classes.message}>
                  {projectChat.message?.content}
                </Typography>
              </CardContent>
            </Card>
          </Link>
        ))
      )}
    </>
  )
}
